var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { RadioGroup } from '@headlessui/react';
import * as styles from './radio-group.styles';
import { Typography } from '..';
export var CoreRadioGroup = function (_a) {
    var colour = _a.colour, onChange = _a.onChange, currentValue = _a.currentValue, options = _a.options, _b = _a.selectedOptionBackgroundColor, selectedOptionBackgroundColor = _b === void 0 ? 'white' : _b, onScroll = _a.onScroll;
    var _c = useState(currentValue), stateValue = _c[0], setStateValue = _c[1];
    var onChangeHandler = function (val) {
        onChange(val);
    };
    var handleScroll = function (e) {
        var element = e.target;
        if (onScroll && element.scrollTop) {
            onScroll(element.scrollTop);
        }
    };
    return (_jsx("div", __assign({ onScroll: function (e) { return handleScroll(e); } }, { children: _jsx(RadioGroup, __assign({ value: stateValue, onChange: onChangeHandler, className: styles.wrapper }, { children: options.map(function (option, index) { return (_jsx(RadioGroup.Option, __assign({ value: option.value }, { children: function (_a) {
                    var checked = _a.checked;
                    return (_jsxs("div", __assign({ className: styles.optionsWrapper(index, checked, colour, selectedOptionBackgroundColor) }, { children: [_jsx("div", __assign({ className: styles.groupCircleStyle(checked, colour) }, { children: _jsx("div", { className: styles.inner }) })), !!option.icon && (_jsx("div", __assign({ className: 'ml-2 mr-4 flex h-9 w-9 items-center justify-center rounded-full' }, { children: option.icon }))), _jsx(Typography, { text: option.label, type: 'body', color: checked ? 'textDark' : 'textMid', weight: checked ? 'normal' : 'skinny' })] })));
                } }), 'radio.group.option.' + option.id)); }) })) })));
};
//# sourceMappingURL=radio-group.js.map